import Vue from 'vue';
import Vuex from 'vuex';
import VueLocalStorage from 'vue-localstorage';

import auth from './modules/auth';
import gameStore from './modules/gameStore';

// import utils from './utils';

Vue.use(Vuex);
Vue.use(VueLocalStorage);

const firebaseConfig = {
  apiKey: 'AIzaSyC1DwW4lO8OWz5YLtpZaeyx97C6ELUqeUw',
  authDomain: 'litafl.firebaseapp.com',
  databaseURL: 'https://litafl.firebaseio.com',
  projectId: 'litafl',
  storageBucket: 'litafl.appspot.com',
  messagingSenderId: '354470184562',
  appId: '1:354470184562:web:20e47574f4e59782efa4eb',
  measurementId: 'G-STS49DR6EL',
};

// Initialize Firebase
window.firebase.initializeApp(firebaseConfig);
window.firebase.analytics();
// window.firebase.functions().useFunctionsEmulator('http://localhost:5001'); // Or whatever the port is for your local emulator

export default new Vuex.Store({
  modules: {
    auth,
    game: gameStore,
  },
});
